<template>
  <v-app-bar color="white" height="120px" flat tile>
    <v-container class="py-0">
      <v-sheet
        width="100%"
        height="100%"
        color="transparent"
        class="d-flex justify-space-between align-center"
      >
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="d-block"
            height="100px"
          />
        </router-link>

        <div class="d-flex flex-column align-end">
          <div class="d-flex align-center social">
            <v-btn
              v-for="{ text, link, icon } in social"
              :key="link"
              color="transparent"
              :href="link"
              target="_blank"
              :title="text"
              depressed
              small
              fab
            >
              <v-icon color="primary" size="20">
                {{ icon }}
              </v-icon>
            </v-btn>
          </div>

          <div class="d-flex align-center">
            <div>
              <div
                v-for="({ text, to, dropdown }, keyMenu) in menu"
                :key="keyMenu"
                class="d-inline-flex"
              >
                <v-btn
                  v-if="!dropdown"
                  class="
                    grey--text
                    text--darken-2 text-body-1 text-none
                    font-weight-light
                    px-2 px-lg-3
                    py-5
                    nav-link
                  "
                  :to="to"
                  active-class="nav-link-active"
                  tile
                  depressed
                  text
                >
                  {{ text }}
                </v-btn>

                <v-menu v-else offset-y tile>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="
                        grey--text
                        text--darken-2 text-body-1 text-none
                        font-weight-light
                        px-2 px-lg-3
                        py-5
                        nav-link
                      "
                      active-class="nav-link-active"
                      tile
                      depressed
                      text
                    >
                      {{ text }}
                      <v-icon class="ml-3" size="12"> fa-caret-down </v-icon>
                    </v-btn>
                  </template>
                  <v-list tile>
                    <v-list-item
                      v-for="(item, keyDropdown) in dropdown"
                      :key="keyDropdown"
                      :to="item.to"
                    >
                      <v-list-item-title class="grey--text text--darken-3">
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </div>
        </div>
      </v-sheet>
    </v-container>
  </v-app-bar>
</template>

<script>
import { menu } from "../../../config";
import { getSocial } from "../../../utils/getSocial";

export default {
  data: () => ({
    menu,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
};
</script>

<style lang="scss" scoped>
.social {
  gap: 4px;
}

.nav-link {
  &:before {
    opacity: 0 !important;
  }
}
</style>
